'use client';
import { Input } from '@material-tailwind/react';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { MaterialIcon } from '../../../../MaterialIcon';

export interface EmailInputProps {
  placeholder?: string;
  onChange: (value: string) => void;
  onInput?: () => void;
  type: string;
  value: string;
  error?: boolean;
  height?: number;
  disabled?: boolean;
  validateInput?: (value: string) => void;
}

export const EmailInput: React.FC<EmailInputProps> = ({
  placeholder,
  type,
  onChange,
  onInput,
  disabled = false,
  value,
  error,
  validateInput,
}) => {
  const commonStyles =
    '!pl-10 !py-2 !pr-3 !h-9 md:!h-10 lg:!h-11 rounded-lg md:rounded-xl border-solid border !text-base !font-medium !text-gray-900 placeholder:opacity-100';
  const defaultClassName = `${commonStyles} !border-gray-400 focus:border-solid focus:border focus:!border-gray-600 focus:shadow-form placeholder-gray-700`;
  const errorStyles = `${commonStyles} !border-[#E57373] !bg-[#FFEBEE] focus:shadow-none focus:!border-[#E57373] !placeholder-red-800`;

  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node) &&
        validateInput
      ) {
        validateInput(value);
      }
    };

    if (validateInput) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [value, validateInput]);

  return (
    <div ref={containerRef} className="relative w-full flex">
      <div className="absolute left-3 flex self-center z-1">
        <MaterialIcon
          icon="mail"
          className={classNames('cursor-default text-gray-700', {
            'text-red-800': error,
          })}
        />
      </div>
      <Input
        className={classNames(
          `w-full ${error ? errorStyles : defaultClassName}`,
          'h-9 md:h-10 lg:h-11',
        )}
        // style={{ height: `${height}px` }}
        placeholder={placeholder}
        value={value}
        type={type}
        disabled={disabled}
        ref={inputRef}
        onInput={onInput}
        labelProps={{ className: 'hidden' }}
        containerProps={{
          className: `!min-h-9 md:!min-h-10 lg:!min-h-11 !h-9 md:!h-10 lg:!h-11`,
        }}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
